import React, { useEffect, useState } from 'react'
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Box, Paper, Divider, Stack, CircularProgress } from "@mui/material";
import axios from "../../../utils/fvAxios";
import ButtonV1 from "../../../toolkit/ButtonV1";
import Upload from "../../../icons/Upload";

function SubscriptionFeeHistory({ SubscriptionInfo }) {
    const SubscriptionHistory = SubscriptionInfo?.length > 0 ? SubscriptionInfo : null;

    const [fileContent, setFileContent] = useState({});
    const [isReceiptLoading, setIsReceiptLoading] = useState(false);

    const handleReceiptDownload = (id) => {
        setIsReceiptLoading(true);
        axios.get("Prequalification/DownloadSubscriptionFeePaymentReceipt?transactionId=" + id, {
            responseType: "blob",
        }).then((res) => {
            if (res?.data) {
                if (res?.data instanceof Blob) {
                    const file = new Blob([res?.data], { type: "application/pdf" });
                    const fileURL = URL?.createObjectURL(file);
                    const pdfWindow = window?.open();
                    pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');
                    setIsReceiptLoading(false);
                } else {
                    console.error("Unexpected response format");
                }
            }
            setFileContent(res);
        }).catch((err) => {
            setIsReceiptLoading(false);
            console.error(err);
        }).finally(() => {
            setIsReceiptLoading(false);
        });
    };
    return (
        <div>
            <Box
                border={1}
                borderLeft={1}
                borderRight={1}
                borderColor="#e4e7ec"
                className="mt-2"
                sx={{ background: "#fff", marginBottom: "10px" }}>
                <Stack spacing={2} direction="row">
                    <h2 className='mx-1' style={{ padding: "10px", marginTop: "12px", float: "left" }}>
                        Subscription Fee Payments
                    </h2>
                </Stack>
                <Divider sx={{ backgroundColor: "#667085", height: "2px" }} />
                <TableContainer component={Paper}>
                    <p style={{ fontSize: "15px", color: "#3E4A62", fontWeight: '500', padding: "10px", marginTop: "10px", textAlign: "center" }} hidden={SubscriptionHistory != null}>
                        No Subscription Fee Payments
                    </p>
                    <Table sx={{ minWidth: 1000 }} aria-label="simple table" hidden={SubscriptionHistory == null}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#F2F4F7", color: "#667085" }}>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Transaction ID</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Received Date</TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085" }}>Amount </TableCell>
                                <TableCell style={{ fontSize: "13px", color: "#667085", float: "right" }}>Receipt </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {SubscriptionHistory?.map((row) => (
                                <TableRow
                                    key={row?.paymentTransactionId}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell style={{ fontSize: "13px" }}>{row?.paymentTransactionId}</TableCell>
                                    <TableCell style={{ fontSize: "13px" }}>{GetfVDateFormate("", row?.paymentReceivedDate)}</TableCell>
                                    <TableCell style={{ fontSize: "13px" }}>${row?.paymentReceivedAmount}</TableCell>
                                    <TableCell style={{ fontSize: "13px", float: "right" }} title='Download Subscription Fee Receipt'>
                                        <ButtonV1
                                            className="border-0"
                                            role="tertiary"
                                            variant="outlined"
                                            id="menu_btn"
                                            style={{
                                                marginRight: "10px",
                                                color: "var(--blue50)",
                                            }}
                                            trailingComponent={
                                                isReceiptLoading ? (
                                                    <CircularProgress size={20} />
                                                ) : (
                                                    <Upload stroke="var(--blue50)" />
                                                )
                                            }
                                            //label="Download Subscription Fee Receipt"
                                            onClick={() => handleReceiptDownload(row?.paymentTransactionId)}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </div >
    )
}

export default SubscriptionFeeHistory